import React from 'react';

import { Typography } from 'components/AORedesign';

const WorkflowNoAccess = () => {
  return <Typography>{`You don't have access to view this. If you have any questions, connect with your Business Development Executive.`}</Typography>;
};

export default WorkflowNoAccess;
